import { Injectable } from '@angular/core';
import { ICommonContentWrapperEvent } from './common-content-wrapper.interfaces';
import { CommonEventsService } from '../events/services/events.service';

@Injectable({
	providedIn: 'root',
})
export class CommonContentWrapperService extends CommonEventsService<ICommonContentWrapperEvent> {
}
